export default __webpack_public_path__ + "static/josh_brown-0638871e9b8648a50504ed50b52bd77b.png";